import { useState } from 'react';
import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import { font } from 'asserts/styles/fonts';

import DefaultButton from 'components/button/DefaultButton';
import RadioButton from 'components/button/RadioButton';

import { ReactComponent as IconArrow } from 'asserts/icons/ic_arrow_right_circle_lined.svg';
import { ReactComponent as IconRemove } from 'asserts/icons/ic_remove_circle_lined.svg';
import { ReactComponent as Bullet } from 'asserts/icons/ic_Bullet.svg';
import { ReactComponent as XIcon } from 'asserts/icons/ic_x.svg';
interface GlobalModalProps {
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const DisCountModal = ({ setModal }: GlobalModalProps) => {
  const [select1, setSelect1] = useState(1);
  const [select2, setSelect2] = useState(1);

  const handleClickCloseModal = () => {
    setModal(false);
  };
  const options1 = [
    { value: 1, label: <Label>선택안함</Label> },
    { value: 2, label: <Label>12개월 무료</Label> },
    { value: 3, label: <Label>[프로모션] 기본이용권 10% 할인</Label> }
  ];

  const options2 = [
    { value: 1, label: <Label>선택안함</Label> },
    { value: 2, label: <Label>4,000원 Posture 10%</Label> },
    { value: 3, label: <Label>4,000원 ROM 10%</Label> }
  ];

  return (
    <Wrapper>
      <ModalWrapper>
        <XBtn onClick={handleClickCloseModal}>
          <XIcon />
        </XBtn>
        <Title>멤버십 할인 쿠폰</Title>
        <CardTitle>멤버십1</CardTitle>
        <CouponWrapper>
          <CounponTitle>
            <Bullet />
            기본이용권 할인쿠폰
          </CounponTitle>
          <RadioWrapper>
            <RadioButton value={select1} options={options1} onChange={() => {}} />
          </RadioWrapper>
        </CouponWrapper>
        <CouponWrapper>
          <CounponTitle>
            <Bullet />
            검사이용권 할인쿠폰
          </CounponTitle>
          <RadioWrapper>
            <RadioButton value={select2} options={options2} onChange={() => {}} />
          </RadioWrapper>
        </CouponWrapper>
        <DisCountInfoWrapper>
          <div>
            <H4>할인 전</H4>
            <Price>30000원</Price>
          </div>
          <IconRemove />
          <DisCount>
            <H4>할인</H4>
            <Price>30000원</Price>
          </DisCount>
          <IconArrow />
          <div>
            <H4>할인 후</H4>
            <Price>30000원</Price>
          </div>
        </DisCountInfoWrapper>
        <DefaultButton
          onClick={handleClickCloseModal}
          text="적용하기"
          type="primary"
          style={{
            minWidth: '160px'
          }}
        />
      </ModalWrapper>
    </Wrapper>
  );
};

export default DisCountModal;

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  font-family: 'Noto Sans KR', sans-serif;
  z-index: 9999;
`;

const XBtn = styled.p`
  width: 20px;
  height: 20px;
  margin-left: auto;
  cursor: pointer;
`;

const Title = styled.p`
  color: ${color.black2};
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
`;

const CardTitle = styled.p`
  color: ${color.black2};
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`;

const CouponWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

const CounponTitle = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 24px;
  border: 1px solid ${color.blue};
  color: ${color.blue};
  font-weight: 500;
  line-height: 20px;
`;

const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 640px;
  display: inline-flex;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  border-radius: 16px;
  background: ${color.white2};

  box-shadow: 0px 0px var(--Blur-Blur-16, 16px) 0px
    var(--opacity-black-black-20, rgba(0, 0, 0, 0.2));
`;

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

const DisCountInfoWrapper = styled.div`
  display: flex;
  padding: 24px 32px;
  justify-content: center;
  align-items: center;
  gap: 32px;
  width: 100%;
  border-radius: 12px;
  background: ${color.blue50};

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
`;

const DisCount = styled.div`
  color: ${color.red};
`;

const Label = styled.p`
  ${font.body_medium};
`;

const H4 = styled.p`
  ${font.h4_bold};
`;

const Price = styled.p`
  ${font.body_regular};
`;
